import _ from 'lodash';
import {
  GET_TENANTS_SUCCESS,
} from '../../actions/clients';

const initialTenantsState = {
  byId: {},
  allIds: [],
};

export const clients = (
  state = initialTenantsState,
  action: { type: string },
): typeof initialTenantsState => {
  switch (action.type) {
    case GET_TENANTS_SUCCESS:
      return Object.assign({}, {
        ...state,
        byId: {
          ..._.get(action, ['response', 'entities', 'clients'], {}),
        },
        allIds: _.get(action, ['response', 'result', 'clients'], []),
      });
    default:
      return state;
  }
};

export default clients;
